var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdditionalOccupants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 77,
    viewBox: "0 0 119 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5 42.0061C9.92739 42.0061 0 45.3561 0 51.9547C0 58.6178 9.92739 62 29.5 62C49.0726 62 59 58.65 59 52.0561C59 45.3838 49.0726 42.0061 29.5 42.0061ZM29.4857 0C19.7526 0 11.8281 7.8934 11.8281 17.5931C11.8097 22.2886 13.6231 26.6892 16.9307 30.0115C20.2429 33.3292 24.6561 35.1678 29.3562 35.1862H29.4857C39.2234 35.1862 47.1478 27.2928 47.1478 17.5931C47.1478 7.8934 39.2234 0 29.4857 0Z",
    fill: "#39A2DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89 57.0061C69.0957 57.0061 59 60.3561 59 66.9547C59 73.6178 69.0957 77 89 77C108.904 77 119 73.65 119 67.0561C119 60.3838 108.904 57.0061 89 57.0061ZM88.9854 15C79.0874 15 71.0286 22.8934 71.0286 32.5931C71.0099 37.2886 72.854 41.6892 76.2177 45.0115C79.586 48.3292 84.074 50.1678 88.8537 50.1862H88.9854C98.8882 50.1862 106.947 42.2928 106.947 32.5931C106.947 22.8934 98.8882 15 88.9854 15Z",
    fill: "#9CD0ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalOccupants);
export default __webpack_public_path__ + "static/media/AdditionalOccupants.85bb44df614cf4fb043bc2452494a856.svg";
export { ForwardRef as ReactComponent };